export default __webpack_public_path__ + "static/media/Background_00263.af98921b.png";